import React, {useEffect, useState} from "react";
import {SearchToSelect} from "../../../components";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TemplateSelector from "./TemplateSelector";
import {getLocationsProperty} from "../../../services/locations/api";


function ContentSelector({
  localPagesContentList,
  localPagesTemplateList,
  contentSelectionFunction,
  singleLocationMode,
  localPagesBrandList,
  brandSelectionFunction,
  selectedBrandId,
    locationIds
}) {


    const getContentTiedToBrand = () =>  {
        if(!singleLocationMode){
            return localPagesContentList
        } else if (currentBrandSelection) {
            const myDocs = localPagesContentList.filter(d => {
                return d.brandId === currentBrandSelection._id
            })
            return myDocs
        } else {
            return []
        }
    }
    /**
     * load the brand for the location and make it the selected brand
     */
    const setBrandForLocation = () => {
        if(singleLocationMode && !!selectedBrandId){
            const brand = localPagesBrandList.find(brand => selectedBrandId === brand._id)
            setCurrentBrandSelection(brand)
        }

    }

    const loadLocationsBrands = () => {
        getLocationsProperty({locationIds:locationIds, propertyName:"localPagesBrandId"})
            .then(data =>{
                //data.size = 1 : only one brand so select it.
                //data.size = 0 : no brand, enable brand selector
                //Anything else disable the whole thing and list an error message
                if(data.length == 1){
                    const selection = localPagesBrandList.filter(brand => data.includes(brand._id))
                    setCurrentBrandSelection(selection[0])
                } else if(data.length == 0){
                    setDisableBrandSelector(false)
                } else{
                    setErrorMessage("Cannot bulk edit locations with different brands")
                    setDisableBrandSelector(true)
                }

            })
    }

    const [currentContentSelection, setCurrentContentSelection] = useState();
    const [contentCreatorOpen, setContentCreatorOpen] = useState(false)
    const [currentBrandSelection, setCurrentBrandSelection] = useState()
    const [filteredContents, setFilteredContents] = useState([])
    const [currentTemplateSelection, setCurrentTemplateSelection] = useState()
    const [disableBrandSelector, setDisableBrandSelector] = useState(!singleLocationMode)
    const [errorMessage, setErrorMessage] = useState()
    /**
     * Any time we update currentBrandSelection we need to update the Contents
     */
    useEffect(() => {setFilteredContents(getContentTiedToBrand())},[currentBrandSelection])
    useEffect(() => {setBrandForLocation()},[])
    useEffect( () => {
        if(!singleLocationMode){
            loadLocationsBrands()
        }
    }, [])

    const searchContent = (query) => {
        const lowercase = query.toLowerCase();
        const choices = filteredContents.filter(content => {
            const contentName = getName(content);
            return contentName.toLowerCase().includes(lowercase);
        }).sort();
        return choices
    }

    const getName = (content) => {
        const templateName = localPagesTemplateList.find(template => template._id === content.templateId).templateName
        return templateName
    }

    const contentSelected = (content, createMode= false) => {
        setCurrentContentSelection(content)
        contentSelectionFunction(content, createMode)
    }

    const createContent = () => {
        const doc = {templateId: currentTemplateSelection._id, templateFieldsAndSections: currentTemplateSelection.sections }
        contentSelected(doc, true)
        setContentCreatorOpen(false)
    }

    const searchBrands = (query) => {
        const lowercase = query.toLowerCase();
        const choices = localPagesBrandList.filter(brand => brand.name.toLowerCase().includes(lowercase)).sort();
        return choices
    };

    const brandSelected = (brand) => {
        //To do update the template selection next
        setCurrentBrandSelection(brand)
        brandSelectionFunction(brand)
    }


    return <div className="form-group column">
        <label className="col-sm-1 col-form-label">Brand</label>
        <div className="col-sm-12">
        <SearchToSelect
                placeholder={"Select Brand"}
                disableCaching={true}
                disabled={disableBrandSelector}
                options={localPagesBrandList}
                renderOption={brand => brand.name}
                onSelected={brandSelected}
                getKey={brand => brand._id}
                getSearchResults={({query}) => searchBrands(query)}
                selected={currentBrandSelection}
            />
        </div>

        <label className="col-sm-1 col-form-label">Pages</label>
        <div className="col-sm-12">
            <SearchToSelect
                placeholder={"Select Page"}
                options={filteredContents}
                disableCaching={true}
                disabled={!currentBrandSelection}
                renderOption={content => getName(content) }
                onSelected={contentSelected}
                getKey={content => content.templateId}
                getSearchResults={({query}) => searchContent(query)}
                selected={currentContentSelection}
            />
        </div>
        <div className="col-sm-2 mt-2">
            <button className={"btn btn-secondary"} style={{"marginLeft": "10px"}} disabled={!currentBrandSelection}
                    onClick={() => setContentCreatorOpen(true)}> +
            </button>
        </div>

        {!!errorMessage && <p aria-label="Error messages" className={"text-danger"}> {errorMessage} </p>}

        {contentCreatorOpen && <Modal isOpen={true} toggle={() => setContentCreatorOpen(false)} className="modal-lg">
            <ModalHeader toggle={() => setContentCreatorOpen(false)}>Add Template</ModalHeader>
            <ModalBody>
                <TemplateSelector
                    localPagesTemplateList={localPagesTemplateList}
                    startingValue={currentTemplateSelection}
                    templateSelectedFunction={setCurrentTemplateSelection}
                />
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-outline-secondary" onClick={() => setContentCreatorOpen(false)}>Cancel</button>{" "}
                <button type="button" className="btn btn-secondary" onClick={() => {createContent()}} disabled={!currentTemplateSelection}  >Create</button>{" "}
            </ModalFooter>
        </Modal>}
    </div>

}

export default ContentSelector;